<script>
import AvatarEditable from '@/components/AvatarEditable.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';

export default {
  name: 'UserDetailContactTile',
  components: { AvatarEditable, EllipsisMenu },
  props: {
    contact: Object,
    isMenuAvailable: Boolean,
    grey: Boolean,
    white: Boolean,
    shadow: Boolean,
  },
  computed: {
    contactName() {
      return (this.contact.name && this.contact.surname)
        ? `${this.contact.name} ${this.contact.surname}`
        : this.contact.email;
    },

    menuItems() {
      return [
        { icon: 'trash', text: 'Удалить', handler: () => { this.$emit('deleteContact', this.contact.contactId); } },
      ];
    },
  },
};
</script>

<template lang="pug">
  .b-user-detail-contact-tile(:class="{ grey, white, shadow }")
    ._contact-container
      AvatarEditable._contact-avatar(:avatar="contact.avatar" :editable="false")
      ._contact-info
        ._contact-name {{ contactName }}
    EllipsisMenu(v-if="isMenuAvailable" :items="menuItems")
</template>

<style scoped lang="scss">
.user-detail-contact-tile {
  border-radius: 6px;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__contact-container {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  &__contact-avatar {
    width: 40px;
    height: 40px;
    border: 2px solid #ffffff;
  }

  &__contact-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  &__contact-name {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: normal;
    text-align: left;
  }

  &__contact-role {
    color: rgb(120, 140, 161);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: normal;
    text-align: left;
  }
}

.grey {
  background: rgb(248, 249, 252);
}

.white {
  background: rgb(255, 255, 255);
}

.shadow {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
}
</style>
